<p-dialog
  [(visible)]="errorLogsModal"
  [modal]="true"
  [style]="{ width: '75vw' }"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  (onHide)="closeWorkflowLogsModal()">
  <ng-template pTemplate="header">
    <div class="w-100 has-border">
      <h2>Error Logs</h2>
    </div>
  </ng-template>
  <div class="dialog-section mb-4">
    <p-table
      #dt
      stripedRows
      [rowHover]="true"
      [rows]="25"
      [showCurrentPageReport]="true"
      [scrollable]="true"
      scrollHeight="calc(100vh - 310px)"
      [size]="'small'"
      [resizableColumns]="true"
      [value]="errorLogs"
      styleClass="table-listing"
      [rowHover]="true">
      <ng-template pTemplate="header">
        <tr class="table-head">
          <th class="number">Project Id</th>
          <th class="status">Tracking Number</th>
          <th class="name">Line RecId</th>
          <th class="jname">Message</th>
          <th class="buyer">Provider</th>
          <th class="cust-po">Created Date</th>
        </tr>
        <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-errorLog let-rowIndex="rowIndex">
        <tr class="p-selectable-row">
          <td class="number">
            {{ errorLog.workflowId }}
          </td>
          <td class="status">
            {{ errorLog.trackingNumber }}
          </td>
          <td class="name">
            {{ errorLog.lineRecId }}
          </td>
          <td class="jname">
            {{ errorLog.message }}
          </td>
          <td class="buyer">
            {{ errorLog.provider }}
          </td>
          <td class="cust-po">
            {{ errorLog.createDate | date: "MM-dd-yyyy HH:mm:ss" }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="20">No logs found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-dialog>
